export default __webpack_public_path__ + "static/media/ipfire4.0aea6235.png";